import request from '../index'

/**
 * 获取游戏详情信息
 * @param {*} query
 * @returns
 */
export function getGameInfo(query) {
    return request({
        url: '/trial/game/detail',
        method: 'get',
        params: query
    })
}

/**
 * 首页轮播图
 * @param {*} query
 * @returns
 */
export function bannerList(query) {
    return request({
        url: '/box/BoxBanner/list',
        method: 'get',
        params: query
    })
}

/**
 * 首页板块列表
 * @param {*} query
 * @returns
 */
export function homeModuleList(query) {
    return request({
        url: '/box/BoxFamilyPlate/list',
        method: 'get',
        params: query
    })
}

/**
 * 游戏库和限免游戏
 * @param {*} query
 * @returns
 */
export function gameDatabase(query) {
    return request({
        url: '/box/boxFamily/information/list',
        method: 'get',
        params: query
    })
}

/**
 * 游戏库和限免游戏( 改成网吧端的商品列表了 )
 * @param {*} query
 * @returns
 */
export function boxGoodsList(query) {
    return request({
        url: '/box/goods/list',
        method: 'get',
        params: query
    })
}

/**
 * 新增用户的游戏
 * @param {*} data
 * @returns
 */
export function boxUserGameCreate(data) {
    return request({
        url: '/box/BoxUserGame/create',
        method: 'post',
        data
    })
}

/**
 * 取消用户的游戏
 * @param {*} data
 * @returns
 */
export function cancelBoxUserGame(data) {
    return request({
        url: '/box/BoxUserGame/delete',
        method: 'post',
        data
    })
}

/**
 * 用户的游戏列表
 * @param {*} params
 * @returns
 */
export function getBoxUserGameList(params) {
    return request({
        url: '/box/BoxUserGame/list',
        method: 'get',
        params
    })
}

/**
 * 用户的游戏的详细信息
 * @param {*} params
 * @returns
 */
export function getBoxUserGameInfo(params) {
    return request({
        url: '/box/BoxUserGame/info',
        method: 'get',
        params
    })
}

/**
 * 获取免费游戏
 * @param {*} params
 * @returns
 */
export function getFreeGameList(params) {
    return request({
        url: '/box/boxFamily/gamefree/list',
        method: 'get',
        params
    })
}

/**
 * 获取本地游戏信息
 * @param {*} params
 * @returns
 */
export function getLocalGameList(params) {
    return request({
        url: '/game/local/list',
        method: 'get',
        params
    })
}

/**
 * 游戏库列表
 * @param {*} query
 * @returns
 */
export function getGameList(query) {
    return request({
        url: '/trial/game/list',
        method: 'get',
        params: query
    })
}

/**
 * 热搜游戏列表
 * @param {*} params
 * @returns
 */
export function getHotGameList(params) {
    return request({
        url: '/box/BoxFamilyPromotion/list',
        method: 'get',
        params
    })
}

/**
 * 热搜游戏详情
 * @param {*} params
 * @returns
 */
export function getHotGameDetail(params) {
    return request({
        url: '/box/BoxFamilyPromotion/detail',
        method: 'get',
        params
    })
}
